import React, { Component } from 'react';

import isChildOf from 'helpers/isChildOf';

const ESCAPE_KEY = 27;

/** @component */
export default (Dropdown) => {
  return class CloseDropdownHandler extends Component {
    constructor(props) {
      super(props);
      this.root = document.getElementById('root');
    }
    componentDidMount() {
      this.root?.addEventListener('click', this.handleClickOutside);
      this.root?.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
      this.root?.removeEventListener('click', this.handleClickOutside);
      this.root?.removeEventListener('keydown', this.handleKeyDown);
    }

    /** Make sure the dropdown closes when you click outside of the dropdown. */
    handleClickOutside = ({ target }) => {
      if (!isChildOf(target, 'dropdownItem')) {
        this.props.toggleDropdown();
      }
    };

    /** Close the dropdown on pressing the ESC key */
    handleKeyDown = ({ keyCode }) => {
      if (keyCode === ESCAPE_KEY) {
        this.props.toggleDropdown();
      }
    };

    render() {
      return <Dropdown {...this.props} />;
    }
  };
};
